import {dqs, noop} from './util'
import {get_modal, get_modal_with_buttons} from './ui'

export const notify = (message, type = 'info', on_dismiss = noop) => {
  if(!message) {
    throw new Error('notifications::notify message cannot be empty')
  }

  const notifications = dqs('#notifications')
  notifications.innerHTML = get_modal(message, 'OK', 'OK, dismiss notification', type, on_dismiss)

  const button = dqs('#notifications .modal-footer button')
  button.onclick = () => {
    dqs('nav').setAttribute('aria-hidden', false)
    dqs('main').setAttribute('aria-hidden', false)

    if(on_dismiss() !== false) {
      notifications.classList.remove('d-flex')
      notifications.classList.add('d-none')
    }
  }

  notifications.classList.remove('d-none')
  notifications.classList.add('d-flex')

  dqs('nav').setAttribute('aria-hidden', true)
  dqs('main').setAttribute('aria-hidden', true)

  setTimeout(() => dqs('#notifications .modal-content').focus(), 50)
}

export const okcancel = (message, on_ok = noop) => {
  if(!message) {
    throw new Error('notifications::confirm message cannot be empty')
  }

  const notifications = dqs('#notifications')
  notifications.innerHTML = get_modal_with_buttons(message, 'info', [
    {id: 'okcancel_cancel', label: 'Cancel', action: noop},
    {id: 'okcancel_ok', label: 'OK', action: on_ok}
  ])

  const buttons = dqs('#notifications .modal-footer button')
  // const id = event.target.id
  for(const button of buttons) {
    button.onclick = ({target: {id}}) => {
      if(
        (id === 'okcancel_ok' && on_ok() !== false)
        || id === 'okcancel_cancel'
      ) {
        notifications.classList.remove('d-flex')
        notifications.classList.add('d-none')
      }
    }
  }

  notifications.classList.remove('d-none')
  notifications.classList.add('d-flex')
  setTimeout(() => dqs('#notifications .modal-content').focus(), 50)
}
